export default "__VITE_PUBLIC_ASSET__ffd2b4fb__"